// MaterialDashboard plugin
import Chartist from 'chartist'
import MaterialDashboard from './material-dashboard'
import Notifications from './components/NotificationPlugin'

// Plugins
import GlobalComponents from './globalComponents'
import GlobalDirectives from './globalDirectives'

import Vue from 'vue'
import App from './App'
import { router } from './router'
import { store } from './store/'
import axios from 'axios'
import VueAxios from 'vue-axios'
import JQuery from 'jquery'

window.$ = JQuery

Vue.prototype.$Chartist = Chartist
Vue.use(MaterialDashboard)
Vue.use(Notifications)
Vue.use(GlobalComponents)
Vue.use(GlobalDirectives)
Vue.use(VueAxios, axios)
Vue.use(require('vue-moment'))

// Vue.use(Notifications);

/* eslint-disable no-new */
new Vue({
  el: '#app',
  store,
  router,
  render: h => h(App),
  data: {
    Chartist: Chartist
  }
})
